import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const siteUrl = "https://ssnt.ro";
const noIndexPaths = new Set(["/privacy-policy", "/cookies-policy"]);

const pages = {
  "/": {
    ro: {
      title: "SSNT | Dezvoltare software, aplicații și marketing digital",
      description:
        "SSNT dezvoltă soluții software personalizate, site-uri web, aplicații mobile și servicii de marketing digital pentru afaceri.",
    },
    en: {
      title: "SSNT | Software development, apps and digital marketing",
      description:
        "SSNT builds custom software, websites and mobile applications and provides digital marketing services for businesses.",
    },
  },
  "/projects": {
    ro: {
      title: "Proiecte software și web | SSNT",
      description:
        "Descoperă proiectele SSNT: site-uri web, aplicații mobile și soluții software dezvoltate pentru clienții noștri.",
    },
    en: {
      title: "Software and web projects | SSNT",
      description:
        "Explore SSNT projects, including websites, mobile apps and software solutions developed for our clients.",
    },
  },
  "/warehouse-management-system": {
    ro: {
      title: "Warehouse Management System | SSNT",
      description:
        "Descoperă sistemul SSNT pentru gestionarea depozitelor, cu module web și mobile pentru operațiuni și stocuri.",
    },
    en: {
      title: "Warehouse Management System | SSNT",
      description:
        "Explore the SSNT warehouse management system, with web and mobile modules for warehouse operations and stock management.",
    },
  },
  "/marketing": {
    ro: {
      title: "Servicii de marketing digital | SSNT",
      description:
        "SSNT oferă servicii de marketing digital, campanii PPC și strategii pentru promovarea afacerii tale online.",
    },
    en: {
      title: "Digital marketing services | SSNT",
      description:
        "SSNT provides digital marketing services, PPC campaigns and strategies to promote your business online.",
    },
  },
  "/career": {
    ro: {
      title: "Cariere și locuri de muncă | SSNT",
      description:
        "Vezi oportunitățile de carieră la SSNT și trimite-ne CV-ul pentru a te alătura echipei.",
    },
    en: {
      title: "Careers and jobs | SSNT",
      description:
        "Explore career opportunities at SSNT and send us your CV to join the team.",
    },
  },
  "/contact": {
    ro: {
      title: "Contact și date de identificare | SSNT",
      description:
        "Contactează SSNT pentru proiecte software și marketing digital. Găsești aici adresa, emailul și datele de identificare ale firmei.",
    },
    en: {
      title: "Contact and company details | SSNT",
      description:
        "Contact SSNT about software and digital marketing projects. Find our address, email and company details here.",
    },
  },
  "/privacy-policy": {
    ro: {
      title: "Politica de confidențialitate | SSNT",
      description:
        "Citește politica de confidențialitate SSNT și află cum sunt prelucrate datele personale.",
    },
    en: {
      title: "Privacy policy | SSNT",
      description:
        "Read the SSNT privacy policy and learn how personal data is processed.",
    },
  },
  "/cookies-policy": {
    ro: {
      title: "Politica de cookies | SSNT",
      description:
        "Află cum utilizează site-ul SSNT fișierele cookie și cum le poți gestiona.",
    },
    en: {
      title: "Cookie policy | SSNT",
      description:
        "Learn how the SSNT website uses cookies and how you can manage them.",
    },
  },
};

function setHeadTag(selector, tagName, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement(tagName);
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([name, value]) => {
    element.setAttribute(name, value);
  });
}

function Seo() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const language = i18n.language.startsWith("en") ? "en" : "ro";
    const normalizedPath = pathname.replace(/\/+$/, "") || "/";
    const pagePath = pages[normalizedPath]
      ? normalizedPath
      : normalizedPath.startsWith("/career/")
        ? "/career"
        : "/";
    const { title, description } = pages[pagePath][language];

    document.documentElement.lang = language;
    document.title = title;

    setHeadTag('meta[name="description"]', "meta", {
      name: "description",
      content: description,
    });
    setHeadTag('link[rel="canonical"]', "link", {
      rel: "canonical",
      href: `${siteUrl}${pagePath}`,
    });
    setHeadTag('meta[name="robots"]', "meta", {
      name: "robots",
      content: noIndexPaths.has(pagePath) ? "noindex, follow" : "index, follow",
    });
  }, [pathname, i18n.language]);

  return null;
}

export default Seo;
